export const roundCurrency = (value: number): number => {
  return !isNaN(value) ? Math.round((value + Number.EPSILON) * 100) / 100 : 0.0;
};
